<template>
    <v-container class="pa-0">
        <v-row no-gutters>
            <v-col :cols="12">
                <FormHeader title="EVENT DETAILS" />
            </v-col>
        </v-row>
        <v-container class="white pt-8">
            <v-row no-gutters align="baseline">
                <v-col cols="2">
                    <v-subheader>SCAN NAME</v-subheader>
                </v-col>
                <v-col cols="9" class="pl-4" md="5">
                    <v-sheet>
                        <v-text-field
                                v-model="v.$model.name"
                                required
                                maxLength="30"
                                :counter="30"
                                name="scanName"
                                id="scanName"
                                type="text"
                                single-line
                                dense
                                outlined
                                :error-messages="errorMessages.requiredErrors(v.name)"
                                @focus="v.name.$touch()"
                                @blur="v.name.$touch()"
                        /></v-sheet>
                </v-col>
            </v-row>
            <v-row no-gutters align="baseline" class="pb-3">
                <v-col cols="2">
                    <v-subheader>SCAN TYPE</v-subheader>
                </v-col>
                <v-col cols="10" class="pl-4">
                    <v-radio-group v-model="convertedType" row>
                        <v-radio
                            v-for="item in scanType"
                            :name="item.title"
                            :key="item.id"
                            :label="item.title"
                            :value="item.value"
                            color="success"
                        ></v-radio>
                    </v-radio-group>
                </v-col>
            </v-row>
            <v-row no-gutters align="baseline" v-if="showFrequency">
                <v-col cols="2">
                    <v-subheader>SCAN SCHEDULE EVERY</v-subheader>
                </v-col>
                <v-col cols="2" class="pl-4 mr-2 pr-2 input-72">
                    <v-sheet>
                        <v-text-field
                                v-model.number="v.$model.schedule_every"
                                :error-messages="errorMessages.frequencyErrors(v.schedule_every)"
                                @focus="v.schedule_every.$touch()"
                                @blur="v.schedule_every.$touch()"
                                required
                                name="schedule_every"
                                id="schedule_every"
                                label="schedule_every"
                                type="number"
                                single-line
                                outlined
                                dense
                                min="0"
                        ></v-text-field
                        ></v-sheet>
                </v-col>
                <v-col cols="1">
                    <v-subheader>Minutes</v-subheader>
                </v-col>
                <v-col cols="6" class="pl-6 " md="6">
<!--                    <v-subheader class="black&#45;&#45;text"-->
<!--                    >Insert 0 to pause/stop the schedule scan</v-subheader-->
<!--                    >-->
                </v-col>
            </v-row>
        </v-container>
    </v-container>
</template>

<script>
    import FormHeader from "./FormHeader";

    export default {
        name: "DetailForm",
        components: { FormHeader },
        updated() {
            if (!this.v.$model.type) {
                this.v.$model.type = this.scanType[0].value;
            }
        },
        computed: {
            convertedType: {
                get: function() {
                    const type = this.v.$model.type ? this.v.$model.type : this.scanType[0].value;
                    this.handleScanTypeChange(type);
                    return type;
                },
                set: function(newValue) {
                    this.v.$model.type = newValue;
                }
            }
        },
        methods: {
            isAdsSelected: function () {
                return this.v.$model.type === "ads" || this.v.$model.type === "realtime-ads"
            },
        },
        props: {
            scanType: Array,
            showFrequency: {
                type: Boolean,
                required: true
            },
            errorMessages: {
                type: Object,
                required: true
            },
            v: {
                type: Object,
                required: true
            },
            handleScanTypeChange: {
                type: Function,
                required: true
            }
        }
    };
</script>
